// extracted by mini-css-extract-plugin
export default {"modalContent":"style_modalContent__a-vlX","title":"style_title__uG9Cz","description":"style_description__hi95i","actionIcon":"style_actionIcon__6o1vG"};